import { render, staticRenderFns } from "./MoneyInput2.vue?vue&type=template&id=66302c3a&lang=pug&"
import script from "./MoneyInput2.vue?vue&type=script&lang=js&"
export * from "./MoneyInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports